/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "./organisms/header"
import "./layout.css"
import styled, { createGlobalStyle } from "styled-components"
import Footer from "./organisms/footer"
import { Helmet } from "react-helmet"

const Layout = ({ children }) => {
  return (
    <>
      {/* <Helmet
        meta={[
          {
            name: `charset`,
            content: "utf-8",
          },
          {
            property: `viewport`,
            content: "width=device-width,initial-scale=1",
          },
        ]}
      /> */}
      <GlobalStyle />
      <Header />
      <Main>{children}</Main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const Main = styled.main`
  max-width: 900px;
  margin: 0 auto;

  /* タブレットも含む */
  @media screen and (max-width: 768px) {
    width: 100vw;
  }
`

const GlobalStyle = createGlobalStyle`

/*!
 * ress.css • v2.0.2
 * MIT License
 * github.com/filipelinhares/ress
 */

/* # =================================================================
   # Global selectors
   # ================================================================= */

html {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%; /* Prevent adjustments of font size after orientation changes in iOS */
  word-break: break-word;
  -moz-tab-size: 4;
  tab-size: 4;
}

*,
::before,
::after {
  background-repeat: no-repeat; /* Set background-repeat: no-repeat to all elements and pseudo elements */
  box-sizing: inherit;
}

::before,
::after {
  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */
  vertical-align: inherit;
}

* {
  padding: 0; /* Reset padding and margin of all elements */
  margin: 0;
}

/* # =================================================================
   # General elements
   # ================================================================= */

hr {
  overflow: visible; /* Show the overflow in Edge and IE */
  height: 0; /* Add the correct box sizing in Firefox */
}

details,
main {
  display: block; /* Render the main element consistently in IE. */
}

summary {
  display: list-item; /* Add the correct display in all browsers */
}

small {
  font-size: 80%; /* Set font-size to 80% in small elements */
}

[hidden] {
  display: none; /* Add the correct display in IE */
}

abbr[title] {
  border-bottom: none; /* Remove the bottom border in Chrome 57 */
  /* Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari */
  text-decoration: underline;
  text-decoration: underline dotted;
}

a {
  background-color: transparent; /* Remove the gray background on active links in IE 10 */
}

a:active,
a:hover {
  outline-width: 0; /* Remove the outline when hovering in all browsers */
}

code,
kbd,
pre,
samp {
  font-family: monospace, monospace; /* Specify the font family of code elements */
}

pre {
  font-size: 1em; /* Correct the odd em font sizing in all browsers */
}

b,
strong {
  font-weight: bolder; /* Add the correct font weight in Chrome, Edge, and Safari */
}

/* https://gist.github.com/unruthless/413930 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* # =================================================================
   # Forms
   # ================================================================= */

input {
  border-radius: 0;
}

/* Replace pointer cursor in disabled elements */
[disabled] {
  cursor: default;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; /* Correct the cursor style of increment and decrement buttons in Chrome */
}

[type="search"] {
  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */
  outline-offset: -2px /* Correct the outline style in Safari */
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; /* Remove the inner padding in Chrome and Safari on macOS */
}

textarea {
  overflow: auto; /* Internet Explorer 11+ */
  resize: vertical; /* Specify textarea resizability */
}

button,
input,
optgroup,
select,
textarea {
  font: inherit; /* Specify font inheritance of form elements */
}

optgroup {
  font-weight: bold; /* Restore the font weight unset by the previous rule */
}

button {
  overflow: visible; /* Address overflow set to hidden in IE 8/9/10/11 */
}

button,
select {
  text-transform: none; /* Firefox 40+, Internet Explorer 11- */
}

/* Apply cursor pointer to button elements */
button,
[type="button"],
[type="reset"],
[type="submit"],
[role="button"] {
  cursor: pointer;
  /* PENDING:ボタンの色がおかしくなる？ */
  /* color: inherit; */
}

/* Remove inner padding and border in Firefox 4+ */
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/* Replace focus style removed in the border reset above */
button:-moz-focusring,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  outline: 1px dotted ButtonText;
}

button,
html [type="button"], /* Prevent a WebKit bug where (2) destroys native audio and videocontrols in Android 4 */
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */
}

/* Remove the default button styling in all browsers */
button,
input,
select,
textarea {
  background-color: transparent;
  border-style: none;
}

/* Style select like a standard input */
select {
  -moz-appearance: none; /* Firefox 36+ */
  -webkit-appearance: none; /* Chrome 41+ */
}

select::-ms-expand {
  display: none; /* Internet Explorer 11+ */
}

select::-ms-value {
  color: currentColor; /* Internet Explorer 11+ */
}

legend {
  border: 0; /* Correct color not being inherited in IE 8/9/10/11 */
  color: inherit; /* Correct the color inheritance from fieldset elements in IE */
  display: table; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge and IE */
  white-space: normal; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge 18- and IE */
}

::-webkit-file-upload-button {
  /* Correct the inability to style clickable types in iOS and Safari */
  -webkit-appearance: button;
  color: inherit;
  font: inherit; /* Change font properties to inherit in Chrome and Safari */
}

/* # =================================================================
   # Specify media element style
   # ================================================================= */

img {
  border-style: none; /* Remove border when inside a element in IE 8/9/10 */
  max-width: 100%;
  vertical-align: bottom;
}

/* Add the correct vertical alignment in Chrome, Firefox, and Opera */
progress {
  vertical-align: baseline;
}

svg:not([fill]) {
  fill: currentColor;
}

/* # =================================================================
   # Accessibility
   # ================================================================= */

/* Hide content from screens but not screenreaders */
@media screen {
  [hidden~="screen"] {
    display: inherit;
  }
  [hidden~="screen"]:not(:active):not(:focus):not(:target) {
    position: absolute !important;
    clip: rect(0 0 0 0) !important;
  }
}

/* Specify the progress cursor of updating elements */
[aria-busy="true"] {
  cursor: progress;
}

/* Specify the pointer cursor of trigger elements */
[aria-controls] {
  cursor: pointer;
}

/* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */
[aria-disabled="true"] {
  cursor: default;
}



/* ------------ フォントの指定 ------------ */

/* rootのfont-sizeを100%(16px)に設定 */
html {
font-size: 100%;
}

/* bodyのfont-sizeを1em（16px）に設定 */
body {
  font-size: 1em;
  font-family: "Noto Serif JP",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
  /* 普通のサイトになってしまったのでやめた */
  /* font-family: "Times New Roman", "YuMincho", "Hiragino Mincho ProN", "Yu Mincho", "MS PMincho", serif; */
  font-display: optional;
  line-height: 1.5;
  word-wrap:break-word;

  @supports (-ms-ime-align: auto) {
    word-break: break-all;
  }
}

/* ------------ 見出しの指定 ------------ */
h1, h2, h3, h4, h5 {
  font-weight: bold; /* Android太字 */
  line-height: 1.3;
}

h1 {
  font-size: 1.125rem; /* 18px */
}

h2 {
  font-size: 1rem; /* 16px */
}

h3 {
  font-size: 0.875rem;/* 14px */
}

h4 {
  font-size: 0.75rem;/* 12px */
}

h5 {
  font-size: 0.75rem; /* 12px */
}

/* 上は使っていない */
h1 {
  font-size: 3rem; /* 48px */

  /* タブレットも含む */
  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.5rem; /* 24px */
  /* タブレットも含む */
  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
}

h3 {
  font-size: 0.875rem;/* 14px */
}

h4 {
  font-size: 1.125rem; /* 18px */
}

h5 {
  font-size: 0.75rem; /* 12px */
}

/* 追加リセット指定 */

/* Remove list styles on ul, ol elements with a class attribute */
/* class属性を持つul、ol要素のリストスタイルを削除 */
ul[class],
ol[class] {
  list-style: none;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  color: initial;
  outline: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255,255,255,0.8);
}

button {
  -webkit-tap-highlight-color: rgba(255,255,255,0.8);
}

a:hover {
  text-decoration: none;
  opacity: .8;
}

a:active {
  text-decoration: none;
  opacity: .8;
}

a:focus,
*:focus {
  outline:none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
/* リセットCSSここまで */

/* slick slider */
.slider {
  width: 100%;
  margin: 0 auto;
}

.slider img{
  height: auto;
  width: 100%;

}

/* slickの余白設定 */
.slick-list {
  margin: 0 -.5rem;
}
.slick-slide>div {
  padding: .5rem;
}

/* スライダーのドットを表示するCSS */
.slick-slider {
	margin-bottom: 30px;
}

.slick-dots {
  position:relative;
	bottom: 0px;
	display: block;
	width: 100%;
	padding: 0;
	list-style: none;
	text-align: center;
}

.slick-dots li {
	position: relative;
	display: inline-block;
	width: 20px;
	height: 20px;
	margin: 0 5px;
	padding: 0;

	cursor: pointer;
}

.slick-dots li button {
	font-size: 0;
	line-height: 0;
	display: block;
	width: 20px;
	height: 20px;
	padding: 5px;
	cursor: pointer;
	color: transparent;
	border: 0;
	outline: none;
	background: transparent;
}

.slick-dots li button:hover,
.slick-dots li button:focus {
	outline: none;
}

.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
	opacity: 1;
}

.slick-dots li button:before {
	content: " ";
	line-height: 20px;
	top: 0;
	left: 0;
	width: 12px;
	height: 12px;
	text-align: center;
	opacity: .25;
	background-color: black;
	border-radius: 50%;

}

.slick-dots li.slick-active button:before {
	opacity: .75;
	background-color: black;
}

.slick-dots li button.thumbnail img {
	width: 0;
	height: 0;
}

/* カレンダー */
.Calendar-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.Calendar-grid-item--current {
  font-weight: bold;
}

.Calendar-grid-item.nextMonth,
.Calendar-grid-item.prevMonth {
  color: #999;
}

/* 旧投稿画面用のスタイル */
/* ショップから検索 タブ */
.shop-tab.react-tabs {
  background: #fff;
}
.shop-tab .react-tabs__tab-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: none;
  margin: 0;
}
.shop-tab .react-tabs__tab {
  border: 1px solid transparent;
  border-bottom: none;
  bottom: -1px;
  position: relative;
  text-align: center;
  cursor: pointer;
}
.shop-tab .react-tabs__tab--selected {
  background: transparent;
  border: none;
}

  /* modal開いたときの背景色 */
.ReactModal__Overlay.ReactModal__Overlay--after-open {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* マガジン詳細 外部リンク */
.iframely-responsive>* {
  border-radius: 8px;
}

/* 文字幅を変える */
h1, h2, h3, h4 ,h5 {
  letter-spacing: 0.18rem;
}

p, span, div {
  font-size: 1.125rem;
  letter-spacing: 0.1rem;
  line-height: 1.8;

  /* タブレットも含む */
  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
}

a:hover {
  /* background-color: rgba(255, 255, 255, 0.4); 	リンクにマウスが乗ったら背景色を変更する */
  opacity: 0.6;
  transition-duration: 0.3s;
}

`
